import axios from 'src/utils/axios';

class MgmtVariant {

  // Get Variant Products
  getVariantProducts = (customerId, categoryId) =>
    new Promise((resolve, reject) => {

      let searchUrl = "/api/catalog/product/variant?";

      searchUrl += (categoryId)
        ? `&categoryId=${categoryId}`
        : "";

      searchUrl += (customerId)
        ? `&customerId=${customerId}`
        : "";

      axios.get(searchUrl)

        .then((response) => {

          // FIXED HERE
          if (response.data.data.products) {

            let variants =
              response.data.data.products;

            resolve(variants);

          } else {

            reject(response.data.error);

          }

        })

        .catch((error) => {

          reject(error);

        });

    });


  // Update Variant
  updateVariant = (variantInfo) =>
    new Promise((resolve, reject) => {

      axios.put(
        '/api/admin/catalog/product/variant',
        variantInfo
      )

        .then((response) => {

          if (response.data.data) {

            let variant = response.data.data;

            resolve(variant);

          } else {

            reject(response.data.error);

          }

        })

        .catch((error) => {

          reject(error);

        });

    });
// Add Variant
addVariant = (formData) =>
  new Promise((resolve, reject) => {
    axios.post( '/api/admin/catalog/product/variant',formData)
      .then((response) => {
        if (response.data.data) {
          resolve(response.data.data);
        } else {
          reject(response.data.error);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

const mgmtVariant = new MgmtVariant();

export default mgmtVariant;